import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Snackbar,
  Alert
} from "@mui/material";
import API from "api/API";

export default function UpdateCredentialsDialog({ open, onClose, onSubmit }) {
    const [snackbar, setSnackbar] = React.useState({open: false, message: "", status: "info"});
    const [formData, setFormData] = useState({
        email: "",
        curp: "",
        oldPassword: "",
        newPassword: "",
    });

    const handleChange = (e) => {
        setFormData({
        ...formData,
        [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async() => {
        const data = formData
        const email = data.email
        const curp = data.curp
        const password = data.newPassword
        const oldPassword = data.oldPassword
        
        if(password == oldPassword){
            setSnackbar({open:true, message: "Tu contraseña debe ser distinta", status: "error"})
            return
        }
        
        const requestBody = {
            email: email,
            curp: curp,
            password: password
        };

        const response = await API.patchPassword(requestBody)

        if(response.status == 200){
            if (onSubmit) onSubmit(response.data);
                onClose();
        }else{
            setSnackbar({open:true, message: response.message, status: "error"})
        }
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({open:false, message: snackbar.message, status: snackbar.status})
    };
  return (
     <>
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle >Actualizar contraseña</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField
                        name="email"
                        label="Email"
                        type="email"
                        fullWidth
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <TextField
                        name="curp"
                        label="CURP"
                        fullWidth
                        value={formData.curp}
                        onChange={handleChange}
                    />
                    <TextField
                        name="oldPassword"
                        label="Contraseña Actual"
                        type="password"
                        fullWidth
                        value={formData.oldPassword}
                        onChange={handleChange}
                    />
                    <TextField
                        name="newPassword"
                        label="Nueva Contraseña"
                        type="password"
                        fullWidth
                        value={formData.newPassword}
                        onChange={handleChange}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                Cancelar
                </Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                Guardar
                </Button>
            </DialogActions>
        </Dialog>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} onClose={handleCloseSnackBar}>
            <Alert
                onClose={handleCloseSnackBar}
                severity={snackbar.status}
                variant="filled"
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
    </>
  );
}
